import React from 'react';
import { Toast, ToastType } from './Toast';

export interface ToastData {
  id: string;
  type: ToastType;
  title: string;
  message?: string;
  duration?: number;
}

interface ToastContainerProps {
  toasts: ToastData[];
  onClose: (id: string) => void;
}

/**
 * Toasts must sit above EVERY overlay in the app, otherwise a failure raised
 * from inside a modal is painted underneath that modal's full-viewport
 * backdrop and the user sees nothing at all.
 *
 * This was 10003 — below the crm-v2 contact modals (z-[10200]) and the screen
 * review chrome (z-[10308]). A "Could not update contact" toast fired from the
 * contact Edit modal was therefore invisible, and a failed save looked like a
 * silent no-op. Keep this the highest z-index of any app-chrome layer.
 */
const TOAST_Z_INDEX = 10400;

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  return (
    <div
      className="fixed top-4 right-4 space-y-2 max-w-md"
      style={{ zIndex: TOAST_Z_INDEX }}
      role="status"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          {...toast}
          onClose={onClose}
        />
      ))}
    </div>
  );
};